import React, { useState } from 'react';
import '../styles/Filters.css';

const Filters = ({ onFilterChange, isMobile = false }) => {
  // Default to 'category' on mobile so users immediately see category options
  const [expandedSection, setExpandedSection] = useState(isMobile ? 'category' : 'category');
  const [selectedFilters, setSelectedFilters] = useState({
    category: [],
    priceRange: 'all',
    rating: 'all',
  });

  const filterSections = [
    { id: 'category', label: 'Category' },
    { id: 'size', label: 'Size' },
    { id: 'price', label: 'Price' },
    { id: 'brand', label: 'Brand' },
    { id: 'color', label: 'Color' },
    { id: 'discount', label: 'Discount Range' },
    { id: 'jeans', label: 'Jeans' },
    { id: 'country', label: 'Country of Origin' },
    { id: 'rating', label: 'Rating' },
    { id: 'fabrics', label: 'Fabrics' },
    { id: 'fashion', label: 'Fashion Trends' },
    { id: 'fit', label: 'Fit' },
    { id: 'waist', label: 'Waist Rise' },
    { id: 'type', label: 'Type' },
    { id: 'fade', label: 'Fade' },
    { id: 'distress', label: 'Distress' },
  ];

  const categories = [
    { label: 'Textiles & Fabrics', value: 'textiles' },
    { label: 'Pottery & Ceramics', value: 'pottery' },
    { label: 'Handicrafts', value: 'handicrafts' },
    { label: 'Jewelry', value: 'jewelry' },
    { label: 'Home Decor', value: 'home-decor' },
    { label: 'Woodcraft', value: 'woodcraft' },
    { label: 'Metalwork', value: 'metalwork' },
    { label: 'Leather Goods', value: 'leather' },
    { label: 'Brass & Copper', value: 'brass-copper' },
    { label: 'Stone Art', value: 'stone-art' },
    { label: 'Glass Work', value: 'glass-work' },
    { label: 'Jute & Bamboo', value: 'jute-bamboo' },
  ];

  const priceRanges = [
    { label: 'All Prices', value: 'all' },
    { label: 'Under ₹500', value: '0-500' },
    { label: '₹500 - ₹1000', value: '500-1000' },
    { label: '₹1000 - ₹5000', value: '1000-5000' },
    { label: '₹5000 - ₹10000', value: '5000-10000' },
    { label: 'Above ₹10000', value: '10000-above' },
  ];

  const handleCategoryChange = (category) => {
    const updated = selectedFilters.category.includes(category)
      ? selectedFilters.category.filter((c) => c !== category)
      : [...selectedFilters.category, category];

    setSelectedFilters({ ...selectedFilters, category: updated });
    onFilterChange({ ...selectedFilters, category: updated });
  };

  const handlePriceChange = (price) => {
    setSelectedFilters({ ...selectedFilters, priceRange: price });
    onFilterChange({ ...selectedFilters, priceRange: price });
  };

  const handleRatingChange = (rating) => {
    setSelectedFilters({ ...selectedFilters, rating });
    onFilterChange({ ...selectedFilters, rating });
  };

  const clearFilters = () => {
    setSelectedFilters({
      category: [],
      priceRange: 'all',
      rating: 'all',
    });
    onFilterChange({
      category: [],
      priceRange: 'all',
      rating: 'all',
    });
  };

  const toggleSection = (id) => {
    setExpandedSection(expandedSection === id ? null : id);
  };

  return (
    <div className="filters-container">
      {isMobile ? (
        // Mobile: Left sidebar + Right content
        <div className="filters-mobile-layout">
          <aside className="filters-sidebar">
            {filterSections.map((section) => (
              <button
                key={section.id}
                className={`filter-sidebar-item ${expandedSection === section.id ? 'active' : ''}`}
                onClick={() => toggleSection(section.id)}
              >
                {section.label}
              </button>
            ))}
          </aside>

          <div className="filters-mobile-content">
            {expandedSection === 'category' && (
              <div className="filter-group">
                <h3>Category</h3>
                {categories.map((category) => (
                  <label key={category.value} className="filter-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedFilters.category.includes(category.value)}
                      onChange={() => handleCategoryChange(category.value)}
                    />
                    <span>{category.label}</span>
                  </label>
                ))}
              </div>
            )}

            {expandedSection === 'size' && (
              <div className="filter-group">
                <div className="filter-search">
                  <input type="text" placeholder="Search by Size" className="filter-search-input" />
                </div>
                <div className="filter-section-title">TOP PICKS</div>
                {[{size: '32', count: 2874}, {size: '30', count: 2880}, {size: '28', count: 1758}].map(({size, count}) => (
                  <label key={size} className="filter-checkbox">
                    <input type="checkbox" />
                    <span>{size}</span>
                    <span className="filter-count">{count}</span>
                  </label>
                ))}
                <div className="filter-section-title">ALL SIZE_FACET</div>
                {['S', 'M', 'L', 'XL', 'Xxl', '22', '23', '24', '25'].map((size) => (
                  <label key={size} className="filter-checkbox">
                    <input type="checkbox" />
                    <span>{size}</span>
                    <span className="filter-count">{Math.floor(Math.random() * 500) + 1}</span>
                  </label>
                ))}
              </div>
            )}

            {expandedSection === 'price' && (
              <div className="filter-group">
                <h3>Price Range</h3>
                {priceRanges.map((range) => (
                  <label key={range.value} className="filter-radio">
                    <input
                      type="radio"
                      name="price"
                      value={range.value}
                      checked={selectedFilters.priceRange === range.value}
                      onChange={() => handlePriceChange(range.value)}
                    />
                    <span>{range.label}</span>
                  </label>
                ))}
              </div>
            )}

            {expandedSection === 'rating' && (
              <div className="filter-group">
                <h3>Rating</h3>
                {['4★ & Up', '3★ & Up', '2★ & Up', '1★ & Up'].map((rating) => (
                  <label key={rating} className="filter-radio">
                    <input
                      type="radio"
                      name="rating"
                      value={rating}
                      checked={selectedFilters.rating === rating}
                      onChange={() => handleRatingChange(rating)}
                    />
                    <span>{rating}</span>
                  </label>
                ))}
              </div>
            )}

            {(expandedSection === 'brand' || expandedSection === 'color' || expandedSection === 'discount' || 
              expandedSection === 'jeans' || expandedSection === 'country' || expandedSection === 'fabrics' || 
              expandedSection === 'fashion' || expandedSection === 'fit' || expandedSection === 'waist' || 
              expandedSection === 'type' || expandedSection === 'fade' || expandedSection === 'distress') && (
              <div className="filter-group">
                <p style={{ color: '#999', fontSize: '0.9rem' }}>No options available</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        // Desktop: All expanded
        <>
          <div className="filters-header">
            <span className="filters-title">Filters</span>
            <button className="clear-filters-link" onClick={clearFilters}>
              Clear All
            </button>
          </div>

          <div className="filters-panel">
            <div className="filter-group">
              <h3>Categories</h3>
              {categories.map((category) => (
                <label key={category.value} className="filter-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedFilters.category.includes(category.value)}
                    onChange={() => handleCategoryChange(category.value)}
                  />
                  <span>{category.label}</span>
                </label>
              ))}
            </div>

            <div className="filter-group">
              <h3>Price Range</h3>
              {priceRanges.map((range) => (
                <label key={range.value} className="filter-radio">
                  <input
                    type="radio"
                    name="price"
                    value={range.value}
                    checked={selectedFilters.priceRange === range.value}
                    onChange={() => handlePriceChange(range.value)}
                  />
                  <span>{range.label}</span>
                </label>
              ))}
            </div>

            <div className="filter-group">
              <h3>Rating</h3>
              {['4★ & Up', '3★ & Up', '2★ & Up', '1★ & Up'].map((rating) => (
                <label key={rating} className="filter-radio">
                  <input
                    type="radio"
                    name="rating"
                    value={rating}
                    checked={selectedFilters.rating === rating}
                    onChange={() => handleRatingChange(rating)}
                  />
                  <span>{rating}</span>
                </label>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Filters;
